import { Component, ViewChild } from '@angular/core';
import { ModalComponent } from '../modal.component/modal.component';

@Component(
    {
        selector: './order-full-modal',
        templateUrl: './order-full-modal.component.html',
        styleUrls: ['./order-full-modal.component.scss']
    }
)
export class OrderFullModalComponent
{
    @ViewChild('modal', { static: true })
    public modal: ModalComponent;

    public constructor()
    {
    }

    public onCloseClick(): void
    {
        this.modal.close();
    }

    public open(): void
    {
        this.modal.open();
    }
}
